/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a64069da62b76d559c4199b1765676e09cdc0437";
